import type { UnionTypeLibelle } from '../../../techniques'
import type { Nomenclature } from '../shared'

export const TypeQualification = ['AttestationStage', 'Rncp', 'Cqp', 'BlocCompetences', 'Rs'] as const
export type TypeQualification = (typeof TypeQualification)[number]

export const TypeQualificationLibelle: UnionTypeLibelle<TypeQualification> = {
  AttestationStage: 'Attestation de stage',
  Rncp: 'Certification enregistrée au RNCP (Hors CQP)',
  Cqp: 'Certificat de qualification professionnelle (CQP)',
  BlocCompetences: 'Certificat de compétence professionnel (Bloc de compétences)',
  Rs: 'Certification inscrite au sein du répertoire spécifique',
} as const

export type TypeQualificationNomenclatures = Record<TypeQualification, Nomenclature[]>
export const TypeQualificationNomenclatures: TypeQualificationNomenclatures = {
  AttestationStage: ['formacode'],
  BlocCompetences: ['rncp'],
  Cqp: ['formacode', 'rncp'],
  Rs: ['repertoireSpecifique'],
  Rncp: ['rncp'],
} as const
